export default "__VITE_ASSET__BwzWXDuY__"